// extracted by mini-css-extract-plugin
export default {"navWrapper":"index_navWrapper__-y8c3","nav-box":"index_nav-box__kkI5h","nav-box__image-box":"index_nav-box__image-box__DHqa6","image-box__image":"index_image-box__image__wPgjA"};